<div class="bg py-5">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 tab-view">
        <img src="assets/images/register-image.png" alt="" class="img-fluid" />
      </div>
      <div class="col-lg-6 tab-view">
        <div class="p-4">
          <div class="login-title mb-3">
            <h2>Corporate Registration</h2>
          </div>
          <div>
            <form action="" [formGroup]="partnerregisterForm">
              <div class="form-row">
                <mat-form-field class="material-full-width" appearance="fill">
                  <mat-label>Name <span class="text-danger">*</span></mat-label>
                  <input
                    matInput
                    placeholder="Enter  Name"
                    formControlName="name"
                    [ngClass]="{
                      'is-invalid': add.name.touched && add.name.errors
                    }"
                  />
                  <mat-error *ngIf="add.name.touched && add.name.errors">
                    <span *ngIf="add.name.errors.required"
                      >Name is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-row">
                <mat-form-field class="material-full-width" appearance="fill">
                  <mat-label
                    >Email ID<span class="text-danger">*</span></mat-label
                  >
                  <input
                    matInput
                    placeholder="Enter Email ID"
                    formControlName="email"
                    oninput="this.value = this.value.replace(/[^a-zA-Z0-9@.-+]/g,'')"
                    type="text"
                    (keydown.space)="$event.preventDefault()"
                    [ngClass]="{
                      'is-invalid': add.email.touched && add.email.errors
                    }"
                  />
                  <mat-error *ngIf="add.email.touched && add.email.errors">
                    <span *ngIf="add.email.errors.required"
                      >Email id is required</span
                    >
                    <span *ngIf="add.email.errors.email">
                      <i class="fas fa-exclamation-triangle"></i>
                      Invalid Email
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-row">
                <mat-form-field class="material-full-width" appearance="fill">
                  <mat-label
                    >Phone Number <span class="text-danger">*</span></mat-label
                  >
                  <input
                    matInput
                    type="text"
                    maxlength="10"
                    minlength="10"
                    oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                    placeholder="Enter contact"
                    formControlName="phone"
                    [ngClass]="{
                      'is-invalid': add.phone.touched && add.phone.errors
                    }"
                  />
                  <mat-error *ngIf="add.phone.touched && add.phone.errors">
                    <span *ngIf="add.phone.errors.required"
                      >Phone Number is required</span
                    >
                    <span *ngIf="add.phone.errors.pattern">
                      <i class="fas fa-exclamation-triangle"></i>
                      Phone Number is Invalid
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
            </form>
          </div>
          <div class="text-center">
            <button class="login-btn" (click)="cancelReg()">Cancel</button>
            <button class="login-btn" (click)="registerpartnerAdmin()">
              Register
            </button>
          </div>
          <div id="RegisterModal" class="modal">
            <div class="modal-content text-center">
              <div class="text-center">
                <img
                  class="image-sec"
                  style="width: 100px"
                  src="/assets/images/registration-1.png"
                  alt=""
                />
              </div>
              <h2 style="font-size: 24px; font-weight: 500">
                Thank you for Registering as Corporate
              </h2>
              <p style="font-size: 17px; color: gray; line-height: 1.2">
                Your application is under review. The credentials will be shared
                through email once application is approved.
              </p>
              <div class="text-center">
                <button class="incubatorBtn" (click)="closeModal()">OK</button>
              </div>
            </div>
          </div>
          <div class="account text-center mt-3">
            <span
              >Already have an account?
              <a href="" routerLink="/login"><b>Login</b> </a>
            </span>
          </div>
        </div>
      </div>
      <div class="col-lg-6 mobile-view">
        <div class="p-4">
          <div class="login-title mb-3">
            <h2>Corporate Registration</h2>
          </div>
          <div>
            <form action="" [formGroup]="partnerregisterForm">
              <div class="form-row">
                <mat-form-field class="material-full-width" appearance="fill">
                  <mat-label>Name <span class="text-danger">*</span></mat-label>
                  <input
                    matInput
                    placeholder="Enter  Name"
                    formControlName="name"
                    [ngClass]="{
                      'is-invalid': add.name.touched && add.name.errors
                    }"
                  />
                  <mat-error *ngIf="add.name.touched && add.name.errors">
                    <span *ngIf="add.name.errors.required"
                      >Name is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-row">
                <mat-form-field class="material-full-width" appearance="fill">
                  <mat-label
                    >Email ID<span class="text-danger">*</span></mat-label
                  >
                  <input
                    matInput
                    placeholder="Enter Email ID"
                    formControlName="email"
                    oninput="this.value = this.value.replace(/[^a-zA-Z0-9@.-+]/g,'')"
                    type="text"
                    (keydown.space)="$event.preventDefault()"
                    [ngClass]="{
                      'is-invalid': add.email.touched && add.email.errors
                    }"
                  />
                  <mat-error *ngIf="add.email.touched && add.email.errors">
                    <span *ngIf="add.email.errors.required"
                      >Email id is required</span
                    >
                    <span *ngIf="add.email.errors.email">
                      <i class="fas fa-exclamation-triangle"></i>
                      Invalid Email
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-row">
                <mat-form-field class="material-full-width" appearance="fill">
                  <mat-label
                    >Phone Number <span class="text-danger">*</span></mat-label
                  >
                  <input
                    matInput
                    type="text"
                    maxlength="10"
                    minlength="10"
                    oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                    placeholder="Enter contact"
                    formControlName="phone"
                    [ngClass]="{
                      'is-invalid': add.phone.touched && add.phone.errors
                    }"
                  />
                  <mat-error *ngIf="add.phone.touched && add.phone.errors">
                    <span *ngIf="add.phone.errors.required"
                      >Phone Number is required</span
                    >
                    <span *ngIf="add.phone.errors.pattern">
                      <i class="fas fa-exclamation-triangle"></i>
                      Phone Number is Invalid
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
            </form>
          </div>
          <div class="text-center">
            <button class="login-btn" (click)="cancelReg()">Cancel</button>
            <button class="login-btn" (click)="registerpartnerAdmin()">
              Register
            </button>
          </div>
          <div id="RegisterModal" class="modal">
            <div class="modal-content text-center">
              <div class="text-center">
                <img
                  class="image-sec"
                  style="width: 100px"
                  src="/assets/images/registration-1.png"
                  alt=""
                />
              </div>
              <h2 style="font-size: 24px; font-weight: 500">
                Thank you for Registering as Corporate
              </h2>
              <p style="font-size: 17px; color: gray; line-height: 1.2">
                Your application is under review. The credentials will be shared
                through email once application is approved.
              </p>
              <div class="text-center">
                <button class="incubatorBtn" (click)="closeModal()">OK</button>
              </div>
            </div>
          </div>
          <div class="account text-center mt-3">
            <span
              >Already have an account?
              <a href="" routerLink="/login"><b>Login</b> </a>
            </span>
          </div>
        </div>
      </div>
      <div class="col-lg-6 mobile-view">
        <img src="assets/images/register-image.png" alt="" class="img-fluid" />
      </div>
    </div>
  </div>
</div>
